// ===============================================
// 🛡️ ROTA PROTEGIDA - INHOLDING
// ===============================================
// Arquivo: src/components/ProtectedRoute.js

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();


  // Enquanto carrega, mostrar tela de loading
  if (loading) {
    return (
      <div className="protected-loading">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <div className="loading-content">
            <h3>InHolding</h3>
            <p>Verificando autenticação...</p>
          </div>
        </div>
        
        <style jsx>{`
          .protected-loading {
            min-height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            font-family: 'Inter', 'Segoe UI', sans-serif;
          }
          
          .loading-container {
            text-align: center;
            background: rgba(255, 255, 255, 0.1);
            padding: 40px;
            border-radius: 20px;
            backdrop-filter: blur(10px);
            border: 1px solid rgba(255, 255, 255, 0.2);
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
          }
          
          .loading-spinner {
            width: 40px;
            height: 40px;
            border: 4px solid rgba(255, 255, 255, 0.3);
            border-top: 4px solid white;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            margin: 0 auto 20px;
          }
          
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          
          .loading-content h3 {
            margin: 0 0 8px 0;
            font-size: 24px;
            font-weight: 700;
          }
          
          .loading-content p {
            font-size: 16px;
            opacity: 0.9;
            margin: 0;
            font-weight: 500;
          }

          @media (max-width: 480px) {
            .loading-container {
              padding: 30px 20px;
              margin: 20px;
            }
            
            .loading-content h3 {
              font-size: 20px;
            }
            
            .loading-content p {
              font-size: 14px;
            }
            
            .loading-spinner {
              width: 35px;
              height: 35px;
              border-width: 3px;
            }
          }
        `}</style>
      </div>
    );
  }

  // Se não estiver autenticado, redirecionar para login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Se estiver autenticado, renderizar o componente
  return children;
};

export default ProtectedRoute;